export const PAGE_DISPLAY_NAME = 'Specs & Features';
export const URL_PATH = 'features-specs';

export const FEATURES_SPECS_HEADER_SRC_INLINE = {
  true: 'data:image/svg+xml,%3Csvg width="375" height="256" fill="none" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M375.194 0H0V256.614H375.194V0Z" fill="url(%23paint0_linear_3663_8664)"/%3E%3Cmask id="mask0_3663_8664" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-492" y="-63" width="1211" height="276"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M-492 165.457L-479.78 -63H695.825L719 143.159C527.915 162.199 307.997 210.799 107.532 213C-92.6034 210.711 -301.233 184.477 -492 165.457Z" fill="url(%23paint1_linear_3663_8664)"/%3E%3C/mask%3E%3Cg mask="url(%23mask0_3663_8664)"%3E%3Cpath d="M525.502 1677.59C597.503 1671.01 670.031 1649.07 742.823 1611.06C1265.56 1338.36 1670.92 317.772 1850 -991.598C1597.08 -193.255 1092.28 220.537 525.502 238.083C-41.2744 219.806 -545.808 -193.255 -798.998 -991.598C-619.919 317.772 -214.551 1338.36 308.181 1611.06C380.973 1648.34 453.501 1670.28 525.502 1677.59Z" fill="%23FEF3C7" fill-opacity="0.07"/%3E%3Cpath d="M773.499 1.25586C877.573 10.7615 982.409 42.448 1087.63 97.3691C1843.21 491.324 2429.15 1965.75 2688 3857.37C2322.41 2704.02 1592.75 2106.22 773.499 2080.88C-45.7485 2107.28 -775.027 2704.02 -1141 3857.37C-882.151 1965.75 -296.212 491.324 459.372 97.3691C564.589 43.5044 669.425 11.8176 773.499 1.25586Z" fill="%23FEF3C7" fill-opacity="0.05"/%3E%3Cpath d="M172.155 601.468C285.888 682.171 398.568 787.8 509.685 919.259C1307.67 1862.8 1826.77 3881.02 1950.28 6137.64C1646.3 4621.52 894.237 3471.12 -5.26673 2890.3C-909.186 2366.44 -1762.74 2531.02 -2263.93 3573.4C-1817.66 1666.18 -1046.98 438.877 -181.774 515.242C-61.3763 526.971 56.7101 562.852 172.155 601.468Z" fill="%23154A99" fill-opacity="0.19"/%3E%3Cpath d="M1155.34 298.297C1257.78 350.756 1359.82 425.47 1461.02 523.325C2187.79 1225.59 2690.24 2926.4 2847.35 4904.53C2546.05 3612.47 1855.59 2719.31 1046.58 2355.3C234.864 2042.48 -517.69 2331.01 -940 3320.4C-585.039 1556.45 71.6356 340.475 839.603 263.404C946.493 253.655 1051.85 265.686 1155.34 298.297Z" fill="%236E28C3" fill-opacity="0.08"/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id="paint0_linear_3663_8664" x1="187.567" y1="34.3916" x2="187.809" y2="389.601" gradientUnits="userSpaceOnUse"%3E%3Cstop stop-color="%23007EE5"/%3E%3Cstop offset="1" stop-color="%2363D9EA"/%3E%3C/linearGradient%3E%3ClinearGradient id="paint1_linear_3663_8664" x1="108.022" y1="-63" x2="108.022" y2="368.277" gradientUnits="userSpaceOnUse"%3E%3Cstop stop-color="%23154A99"/%3E%3Cstop offset="1" stop-color="%2363D9EA"/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E',
  false:
    'data:image/svg+xml,%3Csvg width="1198" height="260" fill="none" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M0 205.23L0 0H1198V177.711C1003.77 226.705 793.437 254.329 575.007 260.259C374.807 260.23 181.095 241.871 0 205.23Z" fill="url(%23paint0_linear_3663_12153)"/%3E%3Cmask id="mask0_3663_12153" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-115" y="-105" width="1438" height="328"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M-114.5 166.5L-100 -105H1295L1322.5 140C1090 174.5 834.795 220.384 596.919 223C359.433 220.279 331.5 219 -114.5 166.5Z" fill="url(%23paint1_linear_3663_12153)"/%3E%3C/mask%3E%3Cg mask="url(%23mask0_3663_12153)"%3E%3Cg opacity="0.6"%3E%3Cpath d="M765.502 787.9C837.503 785.057 910.031 775.58 982.823 759.153C1505.56 641.323 1910.92 200.328 2090 -365.447C1837.08 -20.4854 1332.28 158.313 765.502 165.895C198.725 157.997 -305.808 -20.4854 -558.998 -365.447C-379.919 200.328 25.4487 641.323 548.181 759.153C620.973 775.264 693.501 784.741 765.502 787.9Z" fill="%23FEF3C7" fill-opacity="0.17"/%3E%3Cpath d="M1013.5 28.4893C1104 28.4893 1222.41 46.288 1327.63 70.02C2083.21 240.246 2669.15 877.342 2928 1694.7C2562.41 1196.35 1832.75 938.04 1013.5 927.087C194.251 938.496 -535.027 1196.35 -901.001 1694.7C-642.151 877.342 -56.2118 240.246 699.371 70.02C804.589 46.745 925.828 28.4893 1013.5 28.4893Z" fill="%23FEF3C7" fill-opacity="0.15"/%3E%3Cpath d="M412.155 217.839C525.888 252.71 638.568 298.353 749.685 355.156C1547.67 762.857 2066.77 1634.92 2190.28 2610C1886.3 1954.89 1134.24 1457.81 234.733 1206.84C-669.186 980.48 -1522.74 1051.59 -2023.93 1493.36C-1577.66 669.255 -806.982 138.942 58.2257 171.939C178.624 177.007 296.71 192.511 412.155 217.839Z" fill="%23154A99" fill-opacity="0.29"/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id="paint0_linear_3663_12153" x1="599" y1="-10.1021" x2="599" y2="467.157" gradientUnits="userSpaceOnUse"%3E%3Cstop offset="0.166985" stop-color="%23007EE5"/%3E%3Cstop offset="1" stop-color="%2363D9EA"/%3E%3C/linearGradient%3E%3ClinearGradient id="paint1_linear_3663_12153" x1="597.5" y1="-105" x2="597.5" y2="407.532" gradientUnits="userSpaceOnUse"%3E%3Cstop stop-color="%23154A99"/%3E%3Cstop offset="1" stop-color="%2363D9EA"/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A',
};

export const CUSTOM_MAPPING = {
  'Towing & Hauling': [
    {
      label: 'Max Towing Capacity',
      featureName: 'Maximum towing capacity',
      featureCategory: 'Measurements',
      valuePrefix: 'Up to ',
    },
    {
      label: 'Standard Payload Capacity',
      featureName: 'Maximum payload',
      featureCategory: 'Measurements',
    },
  ],
};

export const OVERVIEW_MAPPING = {
  EV: [
    {
      label: 'Electric Range',
      featureName: 'EPA electricity range',
      featureCategory: 'Fuel',
    },
    {
      label: 'Home Charging Time (240V)',
      featureName: 'EPA time to charge battery (at 240V)',
      featureCategory: 'Fuel',
    },
  ],
  PHEV: [
    {
      label: 'All Electric Range',
      featureName: 'EPA electricity range',
      featureCategory: 'Fuel',
    },
    {
      label: 'Combined MPG',
      description: '(when battery is drained)',
      featureName: 'EPA combined MPG',
      featureCategory: 'Fuel',
    },
  ],
  Gas: [
    {
      label: 'Combined MPG',
      featureName: 'EPA combined MPG',
      featureCategory: 'Fuel',
    },
  ],
};

export const BASIC_MAPPING = {
  // isTruck
  true: [
    {
      label: 'Drive Type',
      featureName: 'Drive type',
      featureCategory: 'Drive Train',
    },
    {
      label: 'Total Seating',
      topLevelKey: 'totalSeating',
    },
    {
      label: 'Bed length',
      featureName: 'Bed length',
      featureCategory: 'Measurements',
    },
    {
      label: 'Standard Payload Capacity',
      featureName: 'Maximum payload',
      featureCategory: 'Measurements',
    },
    {
      label: 'Max Towing Capacity',
      featureName: 'Maximum towing capacity',
      featureCategory: 'Measurements',
      valuePrefix: 'Up to ',
    },
    {
      label: 'Curb Weight',
      featureName: 'Curb weight',
      featureCategory: 'Measurements',
      fallback: {
        label: 'Gross Weight',
        featureName: 'Gross weight',
        featureCategory: 'Measurements',
      },
    },
    {
      label: 'Basic Warranty',
      featureName: 'Basic',
      featureCategory: 'Warranty',
    },
    {
      label: 'Country of final assembly',
      featureName: 'Country of final assembly',
      featureCategory: 'Measurements',
    },
  ],
  // !isTruck
  false: [
    {
      label: 'Drive Type',
      featureName: 'Drive type',
      featureCategory: 'Drive Train',
    },
    {
      label: 'Total Seating',
      topLevelKey: 'totalSeating',
    },
    {
      label: 'Cargo Capacity',
      featureName: 'Cargo capacity, all seats in place',
      featureCategory: 'Measurements',
    },
    {
      label: 'Curb Weight',
      featureName: 'Curb weight',
      featureCategory: 'Measurements',
      fallback: {
        label: 'Gross Weight',
        featureName: 'Gross weight',
        featureCategory: 'Measurements',
      },
    },
    {
      label: 'Basic Warranty',
      featureName: 'Basic',
      featureCategory: 'Warranty',
    },
    {
      label: 'Country of final assembly',
      featureName: 'Country of final assembly',
      featureCategory: 'Measurements',
    },
  ],
};

export const COLORS_FEATURES = [{ name: 'Exterior Colors' }, { name: 'Interior Colors' }];

export const FEATURE_DISPLAY_NAMES = {
  '180 watts stereo output': '180-watt audio output',
  '160 watts stereo output': '160-watt audio output',
  'EV battery': 'EV Battery',
};

export const SECTION_DISPLAY_NAMES = {
  'Drive Train': 'Drivetrain',
  Frontseats: 'Front Seat Dimensions & Features',
  Rearseats: 'Rear Seat Dimensions & Features',
  Fuel: 'Fuel & MPG',
  'Tires and Wheels': 'Tires & Wheels',
  'In Car Entertainment': 'In-Car Entertainment',
  Measurements: 'Exterior Dimensions, Weights & Capacities',
  'Power Feature': 'Power Features',
};

export const EV_SECTION_DISPLAY_NAMES = {
  ...SECTION_DISPLAY_NAMES,
  Fuel: 'Battery & Range',
};

export const OLD_SAFETY_FORMAT_LAST_VEHICLE_YEAR = 2000;

export const OLD_SAFETY_FORMAT_FEATURE_LABELS = {
  O: 'Optional',
  S: 'Standard',
  N: 'Not available',
};

export const NON_NUMBER_FEATURES = ['Fast-charge port type'];

export const PRICED_CATEGORIES = [
  'Packages',
  'Exterior Options',
  'Interior Options',
  'Safety & Security Options',
  'Mechanical Options',
  'Additional Fees Options',
];

export const CUSTOM_SECTION_ANCHOR = {
  PRICING: {
    hash: 'pricing-section',
    name: 'Pricing',
  },
};
